import { RoleService } from './../services/role.service';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoleListResolver implements Resolve<any> {


  constructor(private roleService: RoleService) { }

  resolve(route: import("@angular/router").ActivatedRouteSnapshot, state: import("@angular/router").RouterStateSnapshot) {
    return this.roleService.getRoles();
  }
}
